import React from 'react';
import { Button } from '@mui/material';
import clsx from 'clsx';
import './Button.scss';

function ButtonModule(props) {
	return (
		<>
			<div class="btn">
				<Button
					variant={props.role === 'primary' ? 'contained' : 'outlined'}
					className={
						props.role === 'primary'
							? clsx(props.className, 'primaryBtn')
							: props.role === 'delete'
							? clsx(props.className, 'deleteBtn')
							: props.role === 'export'
							? clsx(props.className, 'exportBtn')
							: props.role === 'filter'
							? clsx(props.className, 'filterBtn')
							: props.role === 'add'
							? clsx(props.className, 'addBtn')
							: props.role === 'clearFilter'
							? clsx(props.className, 'clearFilterBtn')
							: clsx(props.className, 'defaultBtn')
					}
					onClick={props.onClick}
					disabled= {props.disabled}
				>
					{props.value}
				</Button>
			</div>
		</>
	);
}

export default ButtonModule;
